// ==================== WhatsAppFloat.js ====================
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const WhatsAppFloat = () => (
  <a 
    href="https://wa.me/+16504479994" 
    target="_blank" 
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110"
  >
    <FontAwesomeIcon icon={faWhatsapp} className="text-white text-2xl" />
  </a>
);

export default WhatsAppFloat;
